define('all/tracking-event',['jquery', 'module'], function($, module) {
    'use strict';

	window.dataLayer = window.dataLayer || [];

	/**
     * category (required)
     * The name you supply for the group of objects you want to track.
     *
     * action (required)
     * A string that is uniquely paired with each category, and commonly used to define the type of user interaction for the web object.
     *
     * label (optional)
     * An optional string to provide additional dimensions to the event data.
     *
     * value (optional)
     * An integer that you can use to provide numerical data about the user event.
     *
     * non-interaction (optional)
     * A boolean that when set to true, indicates that the event hit will not be used in bounce-rate calculation.
     */
    function addEvent(category, action, opt_label, opt_value, opt_noninteraction) {
        var eventArray = [category, action ? action.replace(/ /g,'-') : action, opt_label ? opt_label.replace(/ /g,'') : opt_label];

		dataLayer.push({
			'event': 'trackEvent',
			'eventCategory' : category,
			'eventAction' : action,
			'eventOptLabel': opt_label,
			'eventOptValue' : opt_value,
			'eventOptNoninteraction' : opt_noninteraction
		});

        if(top.window.optimizely){
            top.window.optimizely.push(["trackEvent", eventArray.join('_')]);
        }

    }

    return {
        add: addEvent
    }
});


